import React from 'react';

const Status = ({ rowData }) => {
    return (
        <span>
            {rowData.status === "o" ?
                "جاری" :
            rowData.status === "e" ?
                "منقضی" :
            rowData.status === "a" ?
                "تایید شده" :
            rowData.status === "r" &&
                "رد شده"
            }
        </span>
    );
}

export default Status;
